import { DatabaseFieldType } from '@databases/types/database';

import { messages } from './messages';

export const fieldTypesNames = {
  [DatabaseFieldType.TEXT]: messages['field-settings.type-text'],
  [DatabaseFieldType.IMAGE]: messages['field-settings.type-image'],
  [DatabaseFieldType.NUMBER]: messages['field-settings.type-number'],
  [DatabaseFieldType.DATE]: messages['field-settings.type-date'],
  [DatabaseFieldType.SELECT]: messages['field-settings.type-tag'],
  [DatabaseFieldType.USER]: messages['field-settings.type-user'],
  [DatabaseFieldType.HYPERLINK]: messages['field-settings.type-link'],
  [DatabaseFieldType.PAGE_LINK]: messages['field-settings.type-page-link'],
  [DatabaseFieldType.PAGE_STATUS]: messages['field-settings.type-page-status'],
  [DatabaseFieldType.PAGE_LABELS]: messages['field-settings.type-page-label'],
  [DatabaseFieldType.PAGE_DETAILS]: messages['field-settings.type-page-details'],
  [DatabaseFieldType.ENTRY_LINK]: messages['field-settings.type-entry-link'],
  [DatabaseFieldType.ENTRY_DETAILS]: messages['field-settings.type-entry-details'],
  [DatabaseFieldType.BACKLINK]: messages['field-settings.type-entry-backlink'],
  [DatabaseFieldType.JIRA_ISSUE]: messages['field-settings.type-jira-issue'],
  [DatabaseFieldType.JIRA_ISSUE_DETAILS]:
    messages['field-settings.type-jira-issue-details'],
};
